import * as React from 'react';

import { Button, Props as ButtonProps } from '../Button';
import { classes } from '../utils';

import styles from './styles.module.css';

type PhoenixOutlinedButtonProps = {
  colorMode?: 'light' | 'dark';
};

export type TransparentButtonProps = ButtonProps &
  PhoenixOutlinedButtonProps & {
    size?: 'default' | 'small';
  };

export const TransparentButton = React.forwardRef<
  HTMLButtonElement,
  TransparentButtonProps
>(function TransparentButtonComponent(props: TransparentButtonProps, ref) {
  const {
    size = 'default',
    name = 'transparent-button',
    colorMode = 'light',
    disabled,
  } = props;

  const cx =
    props.version === 'phoenix'
      ? classes(
          [
            styles[`transButton-${props.version}`],
            styles[size],
            styles[disabled ? 'disabled' : ''],
            styles[colorMode],
          ],
          {
            ...props,
            name,
          }
        )
      : classes([styles.transButton, styles[size]], {
          ...props,
          name,
        });

  return <Button {...props} className={cx} ref={ref} />;
});
